// Bausteine der Startseite und Zähler der Navigation: überfällige Forderungen, Rechnungen zu schreiben,
// Verbindlichkeiten, die diese Woche fällig werden.
import { defineContract } from '@shared/contract'
import { zId } from '@shared/ids'
import { z } from 'zod'

const zWidgetRow = z.object({ id: zId, title: z.string(), subtitle: z.string(), valueCents: z.int(), href: z.string(), tone: z.enum(['neutral', 'warning', 'danger']) })
const zWidget = z.object({ count: z.int(), totalCents: z.int(), rows: z.array(zWidgetRow) })

export const overdueReceivables = defineContract({
  name: 'finance.overview.overdueReceivables',
  title: 'Überfällige Forderungen anzeigen',
  description: 'Kunden mit überfälligen Rechnungen – die größten Beträge zuerst.',
  llm: {
    description: 'Kurzüberblick: Zahl und Summe (Cent) der überfälligen Forderungen und die Kunden mit den größten überfälligen Beträgen. Für die Startseite; die vollständige Liste ist finance.openItem.list mit state "overdue".',
    keywords: ['überfällig', 'Außenstände', 'wer zahlt nicht'],
  },
  input: z.strictObject({}),
  output: zWidget,
  permission: 'finance.openItem.read',
  risk: 'read',
  scope: 'any',
})

export const invoicesToIssue = defineContract({
  name: 'finance.overview.invoicesToIssue',
  title: 'Rechnungen zu schreiben anzeigen',
  description: 'Kunden mit zugestellten, noch nicht berechneten Lieferungen.',
  llm: {
    description: 'Kurzüberblick: wie viele Rechnungen der nächste Rechnungslauf schriebe, über welche Summe (Cent brutto), und für welche Kunden. Für die Startseite; die Vorschau jeder Rechnung ist finance.invoiceRun.preview.',
    keywords: ['Rechnungen zu schreiben', 'abzurechnen', 'unberechnete Lieferungen'],
  },
  input: z.strictObject({}),
  output: zWidget,
  permission: 'finance.invoice.read',
  risk: 'read',
  scope: 'any',
})

export const payablesDue = defineContract({
  name: 'finance.overview.payablesDue',
  title: 'Fällige Verbindlichkeiten anzeigen',
  description: 'Eingangsrechnungen, die in den nächsten sieben Tagen fällig werden oder deren Skontofrist abläuft.',
  llm: {
    description: 'Kurzüberblick: Zahl und Summe (Cent) der Eingangsrechnungen, die in den nächsten sieben Tagen fällig werden, überfällig sind oder deren Skontofrist abläuft. Für die Startseite; der vollständige Vorschlag ist finance.payable.proposal.',
    keywords: ['diese Woche zahlen', 'fällige Lieferantenrechnungen', 'Verbindlichkeiten fällig'],
  },
  input: z.strictObject({}),
  output: zWidget,
  permission: 'finance.supplierInvoice.read',
  risk: 'read',
})
